module.exports = __webpack_public_path__ + "img/Patch13.97fc1463.webp";